import formatInputValue from "../helpers/format-input-value";

export default (data = {}) => {
    const {
        fullname = "",
        lead = {}
    } = data || {};

    const {
        phone = "",
        vehicle_reg_no: regNumber = "",
        make_display: make = "",
        model_display: model = ""
    }  = lead || {};

    return {
        ...data,
        phone,
        carDetails: {
            phone,
            fullname,
            regNumber: formatInputValue(regNumber || ""),
            vehicle: `${make} ${model}`
        }
    };
};
